import React from 'react';
import { ThemeProvider } from 'styled-components';
import { atdsTheme } from '@at/design-system-foundation/lib/atds-theme';
const withStyledTheme = (WC, extendedTheme = {}) => {
    const mergeThemes = Object.assign(atdsTheme, extendedTheme);
    const WithTheme = (props) => {
        return (React.createElement(ThemeProvider, { theme: mergeThemes },
            React.createElement(WC, Object.assign({}, props))));
    };
    return WithTheme;
};
export { withStyledTheme };
